import React from "react";
import { Results } from "@usereactify/search";

import { AnalyticsViewItemListProvider } from "~/providers/AnalyticsViewItemListProvider";

import { withSearchResults } from "./withSearchResults";

export const SearchResults = withSearchResults(
  ({
    renderError,
    renderResultCard,
    renderResultCardCallout,
    renderNoResults,
    renderPaginationNumbered,
    numColumns,
    collection,
  }) => {
    return (
      <AnalyticsViewItemListProvider
        itemListName={
          collection ? (collection.title ?? "Untitled Collection") : "Search"
        }
        itemListId={
          collection
            ? `collection:${collection.handle ?? "untitled"}`
            : "search"
        }
      >
        <div data-id="search-results-list" className="pb-mega">
          <Results
            listStyle={{
              display: "grid",
              gridAutoFlow: "row dense",
              gridGap: "2px 4px",
              gridTemplateColumns: `repeat(${numColumns}, minmax(0, 1fr))`,
            }}
            renderNoResults={renderNoResults}
            renderError={renderError}
            renderResultCardProduct={renderResultCard}
            renderResultCardCallout={renderResultCardCallout}
            renderLoading={() => (
              <span className="pl-midi before:content-['Loading']" />
            )}
            renderPaginationNumbered={renderPaginationNumbered}
          />
        </div>
      </AnalyticsViewItemListProvider>
    );
  },
);
